var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilePrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1846_10715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1028 5.25286L5.27897 10.0767C4.35196 11.0037 2.85028 11.0037 1.92327 10.0767C0.996258 9.14967 0.996258 7.64799 1.92327 6.72098L7.16655 1.4777C7.74541 0.89884 8.68501 0.89884 9.26387 1.4777C9.84272 2.05656 9.84272 2.99615 9.26387 3.57501L4.85951 7.97937C4.6288 8.21007 4.25129 8.21007 4.02058 7.97937C3.78988 7.74866 3.78988 7.37115 4.02058 7.14044L8.00548 3.15555L7.37628 2.52635L3.39139 6.51125C2.81253 7.09011 2.81253 8.0297 3.39139 8.60856C3.97025 9.18742 4.90984 9.18742 5.4887 8.60856L9.89306 4.2042C10.8201 3.27719 10.8201 1.77552 9.89306 0.848504C8.96605 -0.0785078 7.46437 -0.0785078 6.53736 0.848504L1.29408 6.09179C0.0189104 7.36695 0.0189104 9.43071 1.29408 10.7059C2.56924 11.981 4.633 11.981 5.90817 10.7059L10.732 5.88206L10.1028 5.25286Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1846_10715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilePrice);
export default __webpack_public_path__ + "static/media/IconFilePrice.dd647edf.svg";
export { ForwardRef as ReactComponent };